import { Link2Off } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export const PRODUCTION_LINKING_HINT = 'Available after production linking';

/** Makes it explicit that a feature depends on production systems that Central Admin is not linked to yet. */
export function NotLinkedNotice({ children, title = 'Not linked to production.', className }: { children?: ReactNode; title?: string; className?: string }) {
  return (
    <div
      role="note"
      className={cn('flex items-start gap-2.5 rounded-md border border-line-strong bg-surface-sunken px-3 py-2.5 text-[13px] text-ink-secondary', className)}
    >
      <Link2Off size={16} aria-hidden="true" className="mt-px shrink-0 text-ink-muted" />
      <span>
        <span className="font-semibold text-ink">{title} </span>
        {children ??
          'This information lives in production systems (POS cloud, licensing, updater). Central Admin does not read or change it yet.'}
      </span>
    </div>
  );
}

/** Marks records created by `npm run db:seed` — development data, never a real customer. */
export function DemoBadge({ className }: { className?: string }) {
  return (
    <span
      title="Development demo record (npm run db:seed). Not a real customer."
      className={cn(
        'inline-flex h-5 items-center gap-1 rounded border border-warning/30 bg-warning-soft px-1.5 text-[11px] font-semibold uppercase tracking-wide text-warning',
        className,
      )}
    >
      Demo
    </span>
  );
}
